export const VELIKA_SEZONSKA_AKCIJA_ID = "Q29sbGVjdGlvbjoxMg==";
